export const aviMimeTypes = [
  "video/vnd.avi",
  "video/x-msvideo",
  "application/x-troff-msvideo",
  "audio/avi",
  "image/avi",
  "video/avi",
  "video/msvideo",
];
